import React, { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { AiOutlineDelete } from 'react-icons/ai';
import { MdCheckCircle } from 'react-icons/md';
import Loader from 'react-loader-spinner';
import Upload from '../Ui/Upload';

const CustomDocumentModal = ({ t, showModal, loading, handleClose, handleSubmit }) => {
    const [documents, setDocuments] = useState([]);

    useEffect(() => {
        if (showModal) {
            setDocuments([]);
        }
    }, [showModal]);

    const handleSelectDocuments = (files) => {
        const nextFiles = Array.from(files || []);

        if (!nextFiles.length) {
            return;
        }

        setDocuments((prevDocuments) => [...prevDocuments, ...nextFiles]);
    };

    const handleRemoveDocument = (index) => {
        setDocuments((prevDocuments) => prevDocuments.filter((_, documentIndex) => documentIndex !== index));
    };

    const handleUploadAndReset = async () => {
        await handleSubmit(documents);
        setDocuments([]);
    };

    return (
        <div>
            <div className="modal" style={{ display: (showModal ? 'block' : '') }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-bottom">
                            <h5 className="modal-title font-weight-bolder">{t('jobsManagement.infoJob.customDocuments.uploadTitle')}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleClose} style={{ border: 'none', opacity: loading ? 0.5 : 1 }} disabled={loading}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-column mb-2">
                                <label className="form-label mb-2 font-weight-bold">{t('jobsManagement.infoJob.customDocuments.uploadLabel')}</label>
                                <Upload
                                    label="Custom Document"
                                    placeholder={t('jobsManagement.infoJob.customDocuments.uploadPlaceholder')}
                                   
                                    multiple={true}
                                    onChange={(e) => handleSelectDocuments(e.target.files)}
                                    disabled={loading}
                                />
                            </div>

                            <div>
                                {documents.length === 0 ? (
                                    <div className="text-center py-4">
                                        <p className="text-muted mb-0">{t('jobsManagement.noDataAvailable')}</p>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="d-flex align-items-center mb-3">
                                            <span className="badge badge-primary">{documents.length} {documents.length === 1 ? 'file' : 'files'} selected</span>
                                        </div>
                                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                            {documents.map((document, index) => (
                                                <div
                                                    key={`${document.name}-${index}`}
                                                    className="d-flex align-items-center justify-content-between border rounded px-3 py-2 mb-2 bg-light"
                                                    style={{ opacity: loading ? 0.6 : 1 }}
                                                >
                                                    <div className="d-flex align-items-center flex-grow-1">
                                                        {loading && <Loader type="Oval" color="#2d207d" height={16} width={16} style={{ marginRight: '10px' }} />}
                                                        {!loading && <MdCheckCircle style={{ fontSize: '18px', marginRight: '10px', color: '#28a745' }} />}
                                                        <span className="mb-0 text-truncate" title={document.name}>{document.name}</span>
                                                    </div>
                                                    <AiOutlineDelete
                                                        className={loading ? '' : 'c-pointer'}
                                                        style={{ fontSize: '18px', marginLeft: '10px', opacity: loading ? 0.5 : 1 }}
                                                        onClick={() => !loading && handleRemoveDocument(index)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer border-top">
                            <button
                                type="button"
                                className="btn btn-light-danger font-weight-bold"
                                disabled={loading}
                                onClick={handleClose}
                            >
                                {t('jobsManagement.infoJob.createReference.close')}
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary font-weight-bold d-flex align-items-center"
                                disabled={loading || documents.length === 0}
                                onClick={handleUploadAndReset}
                            >
                                {loading ? (
                                    <>
                                        Uploading {documents.length} {documents.length === 1 ? 'file' : 'files'}...
                                        <Loader type="Oval" color="#fff" height={16} width={16} style={{ marginLeft: '10px' }} />
                                    </>
                                ) : (
                                    `Upload ${documents.length} ${documents.length === 1 ? 'file' : 'files'}`
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default CustomDocumentModal;